module.exports = __webpack_public_path__ + "static/media/dashboard.6f865cf1.svg";